import { render, staticRenderFns } from "./BulkOperationButtons.vue?vue&type=template&id=6b3daa3c&scoped=true&"
import script from "./BulkOperationButtons.vue?vue&type=script&lang=js&"
export * from "./BulkOperationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3daa3c",
  null
  
)

export default component.exports